module.exports = __webpack_public_path__ + "9fff4de65fc874d971ee6cec6fae3c21.gif";